// App

// Actions
import { useAppSelector } from '../flux/configureStore';

// Constellation
import { Box, Heading, Text, TextButton } from '@zillow/constellation-10';

// Misc / utils
import { augmentError, formatForLog } from '../utils/errors';
import { logger } from '../index';

type NoResultsPropType = {
  hasActiveFilters: boolean;
};
const NoResults = ({ hasActiveFilters }: NoResultsPropType) => {
  const setFilter = useAppSelector((state) => state.setFilter);
  const handleResetFilters = async () => {
    try {
      await setFilter();
    } catch (err: any) {
      augmentError(err, {
        root: 'components/CompsCarousel/NoResults#handleResetFilters',
      });

      logger.error(formatForLog(err), 'Filter: Error resetting filters');
    }
  };

  /**
   * Once we know if filters are active or not, we can either render
   * "Remove all filters" or "Try another address"
   */

  return (
    <Box css={{ display: 'flex', position: 'relative', flexDirection: 'column', alignItems: 'flex-start' }}>
      <Heading level={4} textStyle="body-lg-bold" css={{ marginTop: '200', marginBottom: '400' }}>
        We were unable to find any comparable listings
      </Heading>
      {hasActiveFilters && (
        <>
          <Text css={{ marginBottom: '400' }}>Edit or remove your filters for best results.</Text>
          <TextButton.Root onClick={handleResetFilters}>
            <TextButton.Label css={{ color: 'text.accent.brand.hero' }}>Remove all filters</TextButton.Label>
          </TextButton.Root>
        </>
      )}
    </Box>
  );
};

export default NoResults;
